<!--优惠券报单-->
<template>
  <div class="order-coupon app-container">
    <!--  收货方式 -->
    <h3 style="color: #b3640d">{{ $t('PoOrder.recType') }}</h3>
    <el-form ref="fromRef" :model="promotionInfo" size="small">
      <el-form-item prop="recType">
        <!--                代办处提货-->
        <el-radio v-model="promotionInfo.recType" label="1" @change="setAgentAddr">
          {{ this.$t('ru.please.goto.agent.toGet') }}
        </el-radio>
        <br>
        <!--                分公司提货-->
        <el-radio v-if="companyCode !== 'COL'" v-model="promotionInfo.recType" label="2" @change="setCompanyAddr">
          {{ this.$t('pick.up.from.branch.office') }}
        </el-radio>
        <br>
        <!--                发到经销商-->
        <el-radio v-model="promotionInfo.recType" label="3" @change="setMemberAddr">
          {{ this.$t('GoodsToMember') }}
        </el-radio>
      </el-form-item>
      <div v-if="promotionInfo.recType === '1'">
        <!--          代办处提货-->
        <el-form-item :label="$t('ru.please.goto.agent.toGet') + ':'" required size="mini" style="width: 100%">
          <el-radio-group v-model="promotionInfo.recNo" size="mini" style="width: 100%" value-key="agentNo">
            <div v-for="(item, index) in AgentGetGoodsList" :key="item.agentNo"
              :class="{ 'under-line': index === AgentGetGoodsList.length - 1 }"
              style="margin: 5px 0;width: 100%;border-top: 1px solid #ddd" @click="agentRadioChange(item)">
              <el-radio :label="item.agentNo" class="agentRadio" style="height: auto;overflow: hidden;">
                <div style="display: inline-block">
                  <p
                    style="display: block;white-space: pre-wrap;word-break:break-word;overflow: hidden;padding-right: 80px">
                    {{ item.companyCode }}&nbsp;&nbsp;{{ item.name }}&nbsp;&nbsp;&nbsp;({{ item.agentNo
                    }})&nbsp;&nbsp;&nbsp;
                    {{ item.mobile }}
                  </p>
                  <p
                    style="display: block;white-space: pre-wrap;word-break:break-word;overflow: hidden;padding-right: 80px">
                    {{ item.storeAddr }}</p>
                </div>
              </el-radio>
            </div>
          </el-radio-group>
        </el-form-item>
      </div>
      <div v-if="promotionInfo.recType === '2'">
        <!--          从分公司提货-->
        <el-form-item :label="$t('pick.up.from.branch.office') + ':'" required size="mini" style="width: 100%">
          <el-radio-group v-model="promotionInfo.outCompanycode" size="mini" style="width: 100%" value-key="agentNo">
            <div v-for="(item, index) in CompanyGetGoodsList" :key="item.City"
              :class="{ 'under-line': index === CompanyGetGoodsList.length - 1 }"
              style="margin: 5px 0;width: 100%;border-top: 1px solid #ddd" @click="outCompanyCodeRadioChange(item)">
              <el-radio :label="item.companyCode" class="companyRadio" style="height: auto;overflow: hidden;">
                <div style="display: inline-block">
                  <p>{{ $t(item.City) }}-{{ $t(item.Country) }}-{{ $t(item.Tel) }}</p>
                  <p>{{ $t(item.Addr) }}</p>
                </div>
              </el-radio>
            </div>
          </el-radio-group>
        </el-form-item>
        <!--          收货电话-->
        <el-form-item :label="$t('ReceiveGoodsPhoneNumber') + (':')" required>
          <el-input v-model="promotionInfo.mobile" />
        </el-form-item>
      </div>
      <div v-if="promotionInfo.recType === '3'">
        <!--          地址-->
        <el-form-item :label="$t('mi.address.id') + ':'" required size="mini">
          <el-select v-model="promotionInfo.countryCode" filterable @change="countryChange" popper-class="selectAddr">
            <el-option v-for="item in countryList" :key="item.id" :label="item.country" :value="item.country" />
          </el-select>
          <!--地区-->
          <span> {{ $t('address.area') }}: </span>
          <el-select v-model="promotionInfo.cityCode" filterable @change="cityChange" popper-class="selectAddr">
            <el-option v-for="item in cityList" :key="item.id" :label="item.province" :value="item.id" />
          </el-select>
        </el-form-item>
        <!--          详细地址-->
        <el-form-item :label="$t('miAgent.storeAddr') + ':'" required size="mini">
          <el-input v-model.trim="promotionInfo.storeAddr" />
        </el-form-item>
        <!--          收货人姓名-->
        <el-form-item :label="$t('busi.JPorder.receiverName') + ':'" required size="mini">
          <el-input v-model="promotionInfo.name" />
        </el-form-item>
        <!--          联系电话-->
        <el-form-item :label="$t('fiBankbookTempRecharge.mobile') + ':'" required size="mini">
          <el-input v-model="promotionInfo.mobile" />
        </el-form-item>
        <!--运费-->
        <el-form-item v-if="promotionInfo.recType === '3'" :label="$t('shipping.cost')">
          250
        </el-form-item>
      </div>
      <!--        备注-->
      <el-form-item :label="$t('Common.remark') + ':'">
        <el-input v-model="promotionInfo.remark" :autosize="{ minRows: 4, maxRows: 6 }" type="textarea"></el-input>
      </el-form-item>
    </el-form>
    <!-- 商品列表 -->
    <h3 style="color: #b3640d">{{ $t('mall.ProductsList') }}</h3>
    <el-table v-loading="doLoading" :data="goodsList" border fit highlight-current-row size="mini" style="width: 100%">
      <!--      购买数量-->
      <el-table-column :label="$t('Common.buyNumber')" align="center" max-width="100">
        <template v-slot="{ row }">
          <el-input class="el-input-center" v-model.number="row.quantity" @change="quantityChange(row)" />
        </template>
      </el-table-column>
      <!--      商品名称-->
      <el-table-column :label="$t('BiGoods.name')" align="center" prop="name" max-width="80">
        <template v-slot="{ row }">
          <el-image v-if="row.imgsrc" :preview-src-list="row.imgsrc.split(';')" :src="row.imgsrc.split(';')[0]"
            fit="contain" style="width: 100%; height: 100%">
          </el-image>
          {{ row.name }}
        </template>
      </el-table-column>
      <!--      价格-->
      <el-table-column :label="$t('pd.price')" align="center" prop="standardPriceB" max-width="80">
        <template v-slot="{ row }">
          {{ row.standardPriceB }}{{ $symbol() }}
        </template>
      </el-table-column>
      <!--      商品编码-->
      <el-table-column :label="$t('BiGoods.goodsCode')" align="center" prop="goodscode" max-width="150" />
    </el-table>
    <!--总价格-->
    <p>{{ $t('TotalPrice') }}: {{ totalAmount }}{{ $symbol() }}</p>
    <!-- 选择优惠券 -->
    <h3 style="color: #b3640d">{{ $t('Select_Coupon') }}</h3>
    <el-radio-group v-if="couponList.length" v-model="coupon" size="mini"
      style="width: 100%;max-height: 400px;overflow-y: auto" @change="couponChange">
      <div v-for="item in couponList" :key="item.id">
        <el-radio :label="item.couponNo" class="coupon-item" :class="{ active: coupon === item.couponNo }">
          <div style="width: 99%;height: 100%;display: flex">
            <div style="flex: 1;height: 100%">
              <div class="left-container">
                <p class="number">{{ item.amountB }}</p>
                <p class="symbol">{{ $symbol() }}</p>
              </div>
            </div>

            <div class="right-container">
              <div class="title">Cash Coupon</div>
              <div class="date">
                {{ getDateString(item.useStartDate) }}-{{ getDateString(getLastSecond(item.useEndDate)) }}
              </div>
            </div>
            <div class="couponNo">
              {{ item.couponNo }}
            </div>
          </div>
        </el-radio>
      </div>
    </el-radio-group>
    <div v-else style="text-align: center">
      {{ $t('No_Coupon') }}
    </div>
    <!--支付金额-->
    <p>{{ $t('busi.pay.amount') }}:
      <span style="color: red;font-size: 20px;font-weight: 600">{{ payAmount }}{{ $symbol() }}</span>
    </p>
    <!--         支付密码 -->
    <h3 style="color: #b3640d">{{ $t('please.input.your.pay.password') }}</h3>
    <el-input v-model.trim="promotionInfo.payPassword" :placeholder="$t('')" clearable show-password />
    <div style="text-align: center;margin-top: 10px">
      <!--立即支付-->
      <el-button size="mini" :loading="doLoading" plain type="primary" @click="handlePay(0)">
        {{ $t('PayImmediately') }}
      </el-button>
      <!--稍后支付-->
      <el-button size="mini" :loading="doLoading" plain type="warning" @click="handlePay(1)">
        {{ $t('btn.pay.later') }}
      </el-button>
      <!--              在线支付-->
      <el-button v-show="companyCode === 'RUS'" size="mini" :loading="doLoading" plain type="primary"
        @click="handlePay(9)">
        {{ $t('menu.onlinePayment') }}
      </el-button>
    </div>
  </div>
</template>

<script>

import { addCouponOrder, commonGetMiAgents, commonGetRecAddrs, goodsListCoupon, getAttendCoupon } from "@/api/rus/api";
import { mapGetters } from "vuex";
import { miMemberInfo2 } from "@/api/userInfo/userInfo";

export default {
  name: 'OrderCoupon',
  directives: {},
  components: {},
  data() {
    return {
      // totalAmount: 0,
      selectedAmount: 0, //选择的优惠券的面值
      companyCodeList: [
        {
          Country: 'MEX_Country',
          City: 'MEX_City',
          Addr: 'MEX_Company_Addr',
          Tel: 'MEX_Company_Tel',
          companyCode: 'MEX'
        },
        {
          Country: 'COL_Country',
          City: 'COL_City',
          Addr: 'COL_Company_Addr',
          Tel: 'COL_Company_Tel',
          companyCode: 'COL'
        },
      ],
      CompanyGetGoodsList: [],
      countryList: [],
      cityList: [],
      AgentInfoObj: null,
      AgentGetGoodsList: [],
      userMemberInfoObj: {},
      promotionInfo: {
        payPassword: null,
        recNo: null,
        recType: null,
        outCompanycode: null,
        mobile: null,
        countryCode: null,
        cityCode: null,
        storeAddr: null,
        name: null,
        remark: null,
        regionCode: null
      },
      goodsList: [],
      couponList: [],
      doLoading: false,
      coupon: null
    }
  },
  computed: {
    ...mapGetters([
      'userCode',
      'companyCode',
      'language'
    ]),
    totalAmount() {
      let totalAmount = 0
      this.goodsList.forEach(item => {
        if (!item.quantity) {
          item.quantity = 0
        }
        if (isNaN(item.quantity)) {
          item.quantity = 0
        }
        totalAmount = this.highPrecisionAdd(totalAmount, this.highPrecisionMul((item.quantity ? item.quantity : 0), item.standardPriceB))
      })
      return totalAmount
    },
    payAmount() {
      let payAmount = 0
      payAmount = this.highPrecisionReduce(this.totalAmount, this.selectedAmount)
      // 优惠券只抵扣商品 不抵扣运费
      if (payAmount < 0) {
        payAmount = 0
      }
      if (this.promotionInfo.recType === '3') {
        payAmount = this.highPrecisionAdd(payAmount, 250)
      }
      return payAmount
    }
  },
  watch: {},
  beforeCreate() {
  },
  async created() {
    this.doLoading = true
    let goodsListRes = await goodsListCoupon()
    this.goodsList = goodsListRes.data
    let couponListRes = await getAttendCoupon()
    this.couponList = couponListRes.data
    console.log(this.couponList, 'this.couponList')
    let getMiAgents = await commonGetMiAgents()
    this.AgentGetGoodsList = getMiAgents.data
    let getRecAddrs = await commonGetRecAddrs({ country: '' })
    this.countryList = getRecAddrs.data
    let miMemberInfo2Res = await miMemberInfo2({ 'code': this.userCode })
    this.userMemberInfoObj = miMemberInfo2Res.data
    this.getCompanyCode()
    this.doLoading = false
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  activated() {
  },
  methods: {
    couponChange() {
      let [selectedItem] = this.couponList.filter(item => item.couponNo === this.coupon)
      console.log(JSON.parse(JSON.stringify(selectedItem)), 'selectedItem')
      this.selectedAmount = selectedItem.amountB
    },
    quantityChange(row) {
      const regex = /^\d+$/
      if (!regex.test(row.quantity)) {
        row.quantity = 0
      }
      if (!row.quantity) {
        row.quantity = 0
      }
      if (row.quantity < 0) {
        row.quantity = 0
      }
    },
    cityChange(val) {
      this.promotionInfo.regionCode = val
    },
    async countryChange(val) {
      this.promotionInfo.cityCode = ''
      this.promotionInfo.regionCode = ''
      this.doLoading = true
      let getRecAddrs = await commonGetRecAddrs({ country: val })
      this.cityList = getRecAddrs.data
      this.doLoading = false
    },
    getCompanyCode() {
      for (let a = 0; a < this.companyCodeList.length; a++) {
        if (this.companyCodeList[a].companyCode === this.companyCode) {
          this.CompanyGetGoodsList.push(this.companyCodeList[a])
        }
      }
    },
    setAgentAddr() {
      this.promotionInfo.storeAddr = this.AgentInfoObj ? this.AgentInfoObj.storeAddr : ''
      this.promotionInfo.name = this.AgentInfoObj ? this.AgentInfoObj.name : ''
      this.promotionInfo.mobile = this.AgentInfoObj ? this.AgentInfoObj.mobile : ''
      this.promotionInfo.recNo = this.AgentInfoObj ? this.AgentInfoObj.agentNo : ''
    },
    setCompanyAddr() {
      this.promotionInfo.outCompanycode = this.CompanyInfoObj ? this.CompanyInfoObj.companyCode : ''
      this.promotionInfo.storeAddr = this.CompanyInfoObj ? this.$t(this.CompanyInfoObj.Addr).toString() : ''
      this.promotionInfo.name = ''
      this.promotionInfo.mobile = this.CompanyInfoObj ? this.$t(this.CompanyInfoObj.Tel).toString() : ''
      this.promotionInfo.recNo = ''
    },
    setMemberAddr() {
      this.promotionInfo.name = this.userMemberInfoObj.accountName
      this.promotionInfo.mobile = this.userMemberInfoObj.mobile
      this.promotionInfo.storeAddr = this.userMemberInfoObj.storeAddr
      this.promotionInfo.recNo = ''
    },
    agentRadioChange(val) {
      this.promotionInfo.storeAddr = val.storeAddr
      this.promotionInfo.name = val.name
      this.promotionInfo.mobile = val.mobile
      this.promotionInfo.recNo = val.agentNo
      this.AgentInfoObj = val
    },
    outCompanyCodeRadioChange(val) {
      this.promotionInfo.outCompanycode = val.companyCode
      this.CompanyInfoObj = val
      this.promotionInfo.storeAddr = this.$t(val.Addr).toString()
      this.promotionInfo.name = ''
      this.promotionInfo.mobile = this.$t(val.Tel).toString()
      this.promotionInfo.recNo = ''
    },
    getLastSecond(dateString) {
      const date = new Date(dateString)
      const timestamp = date.getTime()
      const date2 = new Date(timestamp - 1000)
      const year = date2.getFullYear();
      const month = String(date2.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以需要加1，并且用padStart确保是两位数
      const day = String(date2.getDate()).padStart(2, '0'); // 用padStart确保是两位数
      const hours = String(date2.getHours()).padStart(2, '0'); // 用padStart确保是两位数
      const minutes = String(date2.getMinutes()).padStart(2, '0'); // 用padStart确保是两位数
      const seconds = String(date2.getSeconds()).padStart(2, '0'); // 用padStart确保是两位数
      const formattedDate = `${year}-${month}-${day}`;
      const formattedTime = `${hours}:${minutes}:${seconds}`;
      return `${formattedDate} ${formattedTime}`
    },
    getDateString(dateString) {
      const date = new Date(dateString)
      const timestamp = date.getTime()
      const date2 = new Date(timestamp);
      const localDateTimeString = date2.toLocaleString();
      return localDateTimeString.slice(0, 9)
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    getList() {
      this.doLoading = true
      // TODO:等待接口完成
      // XXXXX({ ...this.listQuery }).then(res => {
      //   this.doLoading = false
      //   this.list = res.data.records
      //   this.total = +res.data.total
      // }).catch(err => {
      //   console.error(err)
      //   this.doLoading = false
      // })
    },
    async handlePay(payType) {
      // payType
      // 0 立即支付
      // 1 稍后支付
      if (!this.promotionInfo.payPassword) {
        return this.$message.error(this.$t('please.input.your.pay.password').toString())
      }
      let goodsList = []
      this.goodsList.forEach(item => {
        if (item.quantity > 0) {
          goodsList.push(item)
        }
      })
      if (goodsList.length === 0) {
        return this.$message.info(this.$t('mi.input.select') + ' ' + this.$t('pmProductSppmDetail.productNo'))
      }
      if (!this.coupon) {
        this.$message.error(this.$t('Select_Coupon').toString())
        return
      }
      // 收货方式验证
      if (!this.promotionInfo.recType) {
        return this.$message.info(this.$t('mi.input.select') + ' ' + this.$t('PoOrder.recType'))
      }
      if (this.promotionInfo.recType === '3') {
        if (!this.promotionInfo.regionCode) {
          this.btnLoading = false
          return this.$message.info(this.$t('mi.input.select') + ' ' + this.$t('mi.address.id')) // 地址
        }
        if (!this.promotionInfo.storeAddr) {
          this.btnLoading = false
          return this.$message.info(this.$t('mi.input.select') + ' ' + this.$t('miAgent.storeAddr')) // 详细地址
        }
        if (!this.promotionInfo.name) {
          this.btnLoading = false
          return this.$message.info(this.$t('mi.input.select') + ' ' + this.$t('busi.JPorder.receiverName')) // 收货人姓名
        }
        if (!this.promotionInfo.mobile) {
          this.btnLoading = false
          return this.$message.info(this.$t('mi.input.select') + ' ' + this.$t('fiBankbookTempRecharge.mobile')) // 联系电话
        }
      } else if (this.promotionInfo.recType === '2') {
        if (!this.promotionInfo.outCompanycode) {
          this.btnLoading = false
          return this.$message.info(this.$t('mi.input.select') + ' ' + this.$t('pick.up.from.branch.office')) //  从分公司提货
        }
      } else if (this.promotionInfo.recType === '1') {
        if (!this.promotionInfo.recNo) {
          this.btnLoading = false
          return this.$message.info(this.$t('mi.input.select') + ' ' + this.$t('ru.please.goto.agent.toGet')) // 代办处提货
        }
      }
      this.promotionInfo.goodsList = goodsList
      this.promotionInfo.couponNo = this.coupon
      this.promotionInfo.memberNo = this.userCode
      this.promotionInfo.payType = payType === 0 ? 0 : 1  // 立即支付 : 稍后支付
      let res = await this.$confirm(this.$t('fi.sure.handle').toString(),
        this.$t('common.tips').toString(),
        {
          confirmButtonText: this.$t('button.confirm').toString(),
          cancelButtonText: this.$t('operation.button.cancel').toString(),
          customClass: 'msgBox',
          type: 'warning'
        })
      if (res === 'confirm') {
        this.doLoading = true
        addCouponOrder({ ...this.promotionInfo })
          .then(async res => {
            console.log(res, 'addCouponOrder')
            this.doLoading = false
            // 订货成功
            this.$message.success(this.$t('OrderGoodsSuccess').toString())
            if (payType === 0 || payType === 1) {
              await this.$router.push({ path: '/order-list/index' })
            } else if (payType === 9) {
              sessionStorage.setItem('PayOnlineData', JSON.stringify(res.data))
              await this.$router.push('/pay-online')
            }
          })
          .catch(err => {
            this.doLoading = false
            console.error(err)
          })
      }

    }
  }
}

</script>

<style lang="scss" scoped>
.order-coupon {
  text-align: left;
}

.el-input-center {
  ::v-deep .el-input__inner {
    background-color: white;
    color: black;
  }

  ::v-deep .el-textarea__inner {
    background-color: white;
    color: black;
  }
}

.el-input-center {
  width: 100%;

  ::v-deep input {
    text-align: center !important;
  }
}

.coupon-item {
  width: 95%;
  height: 180px;
  border-radius: 20px;
  border: 4px solid #ccc;
  margin-bottom: 5px;
  background-image: url("~@/assets/images/coupon-bg.jpg");
  background-size: cover;
  background-position: right;
  background-repeat: no-repeat;

  //background-position: initial;
  //background-size: initial;
  //background-repeat: initial;
  //background-attachment: initial;
  //background-origin: initial;
  //background-clip: initial;
  ::v-deep .el-radio__input {
    display: none;
  }

  ::v-deep .el-radio__label {
    padding: 0;
  }
}

.bg-container {
  width: 5px;
  height: 80px;
  background-color: #fff
}

.active {
  border-color: #266AAD;
  color: #266AAD;

  ::v-deep p {
    color: #266AAD;
  }

  ::v-deep div {
    color: #266AAD;
  }

  ::v-deep .bg-container {
    background-color: #266AAD;
  }
}

.left-container {
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: right;
  text-align: center;
  color: white;

  .number {
    margin: 0;
    font-size: 40px;
    line-height: 180px;
    font-weight: 600;
  }

  .symbol {
    margin: 0 10px 0 0;
    font-size: 30px;
    line-height: 190px;
    font-weight: 600;
  }
}

.right-container {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;

  .title {
    font-size: 20px;
    line-height: 30px;
    margin-left: 10px;
    font-weight: 600;
  }

  .date {
    font-size: 16px;
    margin-left: 10px;
    font-weight: 600;
    line-height: 20px;
  }
}

.couponNo {
  position: absolute;
  top: 10px;
  left: 10px;
}

.agentRadio {
  ::v-deep .el-radio__input {
    height: 100%;
    position: relative;
    top: -30px;
  }
}

.companyRadio {
  ::v-deep .el-radio__input {
    height: 100%;
    position: relative;
    top: -10px;
  }
}
</style>
